import { AgeOptionsType } from './types';

export const AGE_OPTIONS: AgeOptionsType = [
  {
    id: '18-24',
    title: '18-24',
  },
  {
    id: '25-34',
    title: '25-34',
  },
  {
    id: '35-49',
    title: '35-49',
  },
  {
    id: '50_plus',
    title: '50+',
  },
];

export const AGE_OPTIONS_COMPACT: AgeOptionsType = [
  {
    id: '18-24',
    title: 'Young',
  },
  {
    id: '35-49',
    title: 'Experienced',
  },
];
